export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Depósito de botella',
    },
    product_type: {
      label: 'Tipo de producto',
      options: {
        packaged: 'Envasado',
        prepared: 'Preparado',
      },
    },
    packaging_material: {
      label: 'Material de envase',
    },
    brand_or_manufacturer: {
      label: 'Marca o fabricante',
    },
    net_quantity: {
      label: 'Cantidad neta',
    },
    base_price: {
      label: 'Establecer precio por unidad (p. ej. por litro para una bebida)',
      placeholder: 'Precio por unidad',
    },
    alcohol_by_volume_percent: {
      label: 'Porcentaje de alcohol',
    },
    caffeine_mg_per_100ml: {
      label: 'Cafeína (mg por 100 ml de producto)',
    },
    ingredients_text: {
      label: 'Ingredientes',
    },
    allergens_list: {
      label: 'Alérgenos',
    },
    additives_list: {
      label: 'Aditivos',
    },
    has_nutrition_table: {
      label: 'Completar tabla nutricional (por 100{{unit}} de producto)',
    },
    energy_kj: {
      label: 'Energía (kJ)',
    },
    energy_kcal: {
      label: 'Energía (kcal)',
    },
    fat_g: {
      label: 'Grasas',
    },
    saturates_g: {
      label: 'Grasas saturadas',
    },
    carbohydrate_g: {
      label: 'Hidratos de carbono',
    },
    sugars_g: {
      label: 'Azúcares',
    },
    protein_g: {
      label: 'Proteínas',
    },
    salt_g: {
      label: 'Sal',
    },
    identifiers: {
      label: 'Identificadores',
    },
  },
};
